import React from 'react';

// TODO: bring status messages into react-tds!!
export default function StatusMessage({ children, headerText }) {
  return (
    <div className="tds-status_msg tds-status_msg--enclosed" role="alert">
      <i className="tds-icon tds-icon-error tds-status_msg-icon" />
      <div className="tds-status_msg-text">
        {headerText && (
          <div className="tds-status_msg-header">
            <h6>{headerText}</h6>
          </div>
        )}
        <div className="tds-status_msg-body">{children}</div>
      </div>
    </div>
  );
}
